import axios, { AxiosRequestConfig } from "axios";
import { getAPIBaseUrl } from "./getApiBaseUrl";

interface RequestConfig extends AxiosRequestConfig {
  includeReferrerUrlHeader?: boolean;
}

/**
 * Performs an API request.
 * @param options: The request options.
 * @param authToken: The optional authentication token.
 * @param server: The server we are making the request to.
 */
export async function request<T>(options: RequestConfig, authToken?: string, server?: string): Promise<T> {
  const client = axios.create({
    baseURL: getAPIBaseUrl(),
    headers: {
      "X-Referrer-Url": window.location.href,
    },
  });

  if (options?.includeReferrerUrlHeader === false) {
    delete client.defaults.headers["X-Referrer-Url"];
  }

  if (authToken && server !== "S3") {
    client.defaults.headers.common = {
      Authorization: `Bearer ${authToken}`,
    };
  }

  try {
    const result = await client(options);
    return result.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error;
    }
  }
}
